<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TLb2Li/tc-custom/9781473874749.jpg?1721057527920" alt="This image is the cover for the book Sparta: Fall of a Warrior Nation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sparta: Fall of a Warrior Nation
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The author of <i>Sparta: Rise of a Warrior Nation</i> continues his revealing history of the Ancient Greek city-state in this chronicle of its decline and defeat.</b></p> Universally admired in 479 BC, the Spartans became masters of the Greek world by 402 BC, only for their state to collapse in the next generation. What went wrong? Was the fall of Sparta inevitable? In <i>Sparta: Fall of a Warrior Nation</i>, Philip Matyszak examines the political blunders and failures of leadership which combined with unresolved social issues to bring down the nation—even as its warriors remained invincible on the battlefield.<br/><br/> The Spartans believed their society was above the changes sweeping their world. And by resisting change, they were doomed to be overwhelmed by it. But the Spartans refused to accept total defeat, and for many years their city exercised influence far beyond its size and population. This is a chronicle of political failure—one rich in heroes, villains, epic battles and political skullduggery. But it is also a lesson in how to go down fighting. Even with the Roman legions set to overwhelm their city, the Spartans never gave up
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip Matyszak
      </h2>
      
      <p class="authorDescription body article">PHILIP 'MATY' MATYSZAK holds a doctorate in Ancient History from St John's College, Oxford University, and has been studying, teaching and writing on the subject for over twenty years. He specializes in the history of Classical Greece and of the Late Republic and Early Imperial periods of Rome. Maty has personal military experience both as a conscript in Rhodesia and with the Territorial Army in Britain. These days he splits his time between writing in his home in Canada's Monashee Mountains and providing e-learning courses for Cambridge University's Institute of Continuing Education.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27161afb